   import React from 'react';
   import './SkillDisplay.scss';

   function SkillDisplay() {
     return (
       <div className='skill-display'>
         <span></span>
       </div>
     );
   }

   export default SkillDisplay;